import styles from './AboutPage.module.css';

const faqItems = [
  { question: 'Do you accept credit cards?', answer: 'Yes.' },
  { question: 'Do you take reservations?', answer: 'No, but we do offer private parties for larger gatherings.' },
  { question: "What time do you serve food 'til?", answer: 'Typically kitchen closes around 11:30pm, though subject to change based on demand.' },
  { question: 'How many t.v.s do you have?', answer: 'A lot! There is a large projection screen and many big screens scattered throughout the rest of the bar.' },
  { question: 'Can you put my game on?', answer: "Most likely, if it's available." },
  { question: 'Do you have takeout?', answer: 'Yes' },
  { question: 'How much does pool cost?', answer: 'Pool tables are coin operated and are $2.00 a game, there are change machines located in the pool area. Pool tables are first come first serve.' },
  { question: 'Can I have a job?', answer: 'If you would like to apply for a job please come see us in person.' },
];

function AboutPage() {
  return (
    <div className={styles.page}>
      <section className={styles.about}>
        <h1 className={styles.aboutTitle}>About The Hub Pub</h1>
        <article className={styles.aboutText}>
          <p>
            Conveniently located just steps away from Boston's Freedom Trail and nestled in the heart
            of historic downtown, The Hub Pub is a classic American pub offering fine pub dining and a
            casual drinking atmosphere. Whether you're looking for an ice cold beer after work, a great
            place to meet friends, or somewhere to feel at home while you're traveling - The Hub Pub is
            the place to be!
          </p>
        </article>
      </section>

      <section className={styles.faq}>
        <h3 className={styles.faqTitle}>Frequently Asked Questions</h3>
        {faqItems.map((item) => (
          <div key={item.question} className={styles.faqItem}>
            <h4 className={styles.faqQuestion}>{item.question}</h4>
            <p className={styles.faqAnswer}>{item.answer}</p>
          </div>
        ))}
      </section>
    </div>
  );
}

export default AboutPage;
